import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import { getInitialColor, getInitials } from "../../services/commonServices";

const Index = ({
  isOpen,
  closeOpenDialog,
  submitData,
  isSelectAll,
  SelectAll,
  selectedUsersList,
  employeeList,
  selectedUsers,
  selectUser,
  branchList = [],
  departmentList = [],
  state,
  handleInputChange,
  getData,
  searchQuery,
  searchEmployees,
  outletName,
  dataList
}) => {
 
  return (
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={isOpen}
      onClose={closeOpenDialog}
    >
      <DialogTitle className="dialog-title">
        <div className="dialog-title-icon">
          <span className="close-icon" onClick={closeOpenDialog}>
            X
          </span>
          <span className="title">Assign Employees</span>
          <br />
        </div>

        <button className="universal-btn" onClick={submitData}>
          Save Changes
        </button>
      </DialogTitle>
      <DialogContent style={{ paddingTop: "15px" }}>
        <span className="color-white mt-5 mb-2" style={{marginTop: "20px"}}>Name:  {outletName} </span>
        {selectedUsersList.length > 0 && (
          <div className="d-flex align-items-center justify-content-start gap-2 flex-wrap mb-2 mt-2">
            {selectedUsersList.map((row) => {
              return (
                <div
                  className="user-assign-profile" 
                  style={{
                    backgroundColor: getInitialColor(
                      (row?.full_name ?? row?.fullName) || ""
                    ),
                    color: "#fff"
                  }}
                  key={row?.staffId}
                >
                  {getInitials((row?.full_name ?? row?.fullName) || "")}
                </div>
              );
            })}
          </div>
        )}

        <div
          className={`d-flex align-items-center justify-content-start gap-2 mb-3 ${
            selectedUsersList.length > 0 ? "" : "mt-3"
          }`}
        >
          <input
            className="universal-input-one"
            style={{ width: "100%", paddingLeft: "10px" }}
            type="text"
            placeholder="Search employees..."
            value={searchQuery}
            onChange={(e) => searchEmployees(e.target.value, dataList)}
          />
          <select
            name="branchId"
            value={state.branchId}
            onChange={handleInputChange}
            className="universal-input-one"
            style={{ width: "300px", paddingLeft: "6px" }}
          >
            <option>Select Branch</option>
            {branchList.length &&
              branchList.map((row) => {
                return <option key={row.branchId} value={row.branchId}> {row.branch_name} </option>;
              })}
          </select>

          <select
            name="departmentId"
            value={state.departmentId}
            onChange={handleInputChange}
            className="universal-input-one"
            style={{ width: "300px", paddingLeft: "6px" }}
          >
            <option>Select Department</option>

            {departmentList.length &&
              departmentList.map((row) => {
                return (
                  <option key={row.departmentId} value={row.departmentId}>
                    {row.department_name}
                  </option>
                );
              })}
          </select>
        </div>
        
        <div className="mb-3 color-white">
          <input
            type="checkbox"
            checked={isSelectAll}
            onChange={SelectAll}
            id="sel-all"
            className="colored-checkbox"
          />
          <label
            htmlFor={"sel-all"}
            className="colored-checkbox-label"
            
          ></label>
          <label
            style={{
              position: "relative",
              top: "-4px",
              left: "5px",
              cursor: "pointer",
            }}
            htmlFor="sel-all"
          >
            Select All
          </label>
        </div>

        <div style={{ width: "100%" }}>
          {employeeList.length > 0 ? (
            employeeList.map((row) => {
              return (
                <div
                  key={row.staffId}
                  className="d-flex align-items-center justify-content-between"
                >
                  <div className="d-flex align-items-center justify-content-start gap-3 flex-wrap mb-3">
                    <div
                      className="user-assign-profile"
                      style={{
                        backgroundColor: getInitialColor(
                          row.full_name != undefined
                            ? row.full_name
                            : row.fullName
                        ),
                        color: "#fff"
                      }}
                    >
                      {getInitials((row?.full_name ?? row?.fullName) || "")}
                    </div>
                    <div className="d-flex flex-column align-items-start gap-1">
                      <label
                        style={{ cursor: "pointer"}}
                        htmlFor={"assign" + row.staffId}
                        className="color-white"
                      >
                        {(row?.full_name ?? row?.fullName) || ""}
                      </label>
                      <span style={{ fontSize: "12px", color: "gray" }}>
                        {row.employee_id || row.employeeId}
                      </span>
                    </div>
                  </div>
                  <input
                    type="checkbox"
                    checked={selectedUsers.includes(row.staffId)}
                    onChange={(e) => selectUser(e, row.staffId, row)}
                    id={"assign" + row.staffId}
                    className="colored-custom-checkbox"
                  />
                  <label
                    htmlFor={"assign" + row.staffId}
                    className="custom-checkbox-label"
                    style={{ top: "-5px" }}
                  ></label>
                </div>
              );
            })
          ) : (
            <div className="color-white">No employees found</div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Index;